<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eiCuMY/tc-custom/9781399003704.jpg?1706239970026" alt="This image is the cover for the book London Serial Killers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">London Serial Killers
      </h1>
      <p class="bookDescription body article font2">
        <b>An historical true crime accounting of London’s notorious serial murderers and their victims, spanning the Victorian era to the mid-twentieth century.</b><br/><br/>Murders and murderers fascinate us—and perhaps serial killers fascinate us most of all. In the twentieth century the term came to be used to describe murders committed by the same person, often with similar methods. But, as Jonathan Oates demonstrates in this selection of cases from London, this category of crime has existed for centuries, though it may have become more common in modern times. Using police and pathologists’ reports, Home Office and prison files, trial transcripts and lurid accounts in contemporary newspapers, he reconstructs these cases in order to explain how they took place, who the killers were, what motivated them, and how for a while they got away with their crimes. He does not neglect the victims and provides a revealing analysis of the killers, their circumstances and their actions. Among the nineteenth-century cases are the infamous killings of Jack the Ripper and the less-well-known but terrifying crimes of the only female killer, the Deptford Poisoner. Twentieth-century cases covered in forensic detail include the Black-out Ripper of 1942, the Thames Nude Murders of the 1960s and the multiple killings of Joseph Smith, John Christie and John George Haigh. There is also one especially troubling unsolved case—the notorious Soho prostitute killings of the 1930s and 1940s, which may be the work of one man. Jonathan Oates’s gripping accounts of this wide range of serial killings gives us a powerful insight into the nature of these crimes, the characters of the killers and the police methods of the period.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Oates
      </h2>
      
      <p class="authorDescription body article">Dr Jonathan Oates is the Ealing Borough Archivist and Local History Librarian, and he has written and lectured on the Jacobite rebellions and on aspects of the history of London, including its criminal past. He is also well known as an expert on family history and has written several introductory books on the subject including Tracing Your London Ancestors, Tracing Your Ancestors From 1066 to 1837 and Tracing Villains and Their Victims.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword True Crime
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1fb5eb58